/**
 * frame_toggle_controller.js — a link that opens a turbo-frame and, tapped
 * again, closes it (Stimulus).
 *
 * The link names its frame with data-turbo-frame, as any frame link does, so
 * opening is Turbo's own navigation and nothing here fetches. While the frame
 * shows something, the tap closes it instead and Turbo never sees the click.
 *
 * Content with its own close marks that control data-frame-toggle-close, and
 * the tap goes through it, so whatever that close guards (the asset builder
 * asks before dropping unsaved rows) still runs. Without one, the frame is
 * emptied, which is the frame's resting state.
 */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    toggle(event) {
        const frame = document.getElementById(this.element.dataset.turboFrame);
        if (!frame || !frame.childElementCount) return;
        event.preventDefault();
        const close = frame.querySelector('[data-frame-toggle-close]');
        if (close) close.click();
        else frame.innerHTML = '';
    }
}
